module.exports = __webpack_public_path__ + "img/vadofone_logotype_slim.9b547571.svg";